const { io } = require("socket.io-client");

const URL = 'http://konvergence.supplies:3000';
export const socket = io(URL, {
    autoConnect: false // Optionally prevent automatic connection
});

export default socket;